const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const LEGACY_LABEL_KIND = {
    'Invoice Payment': 'pay',
    'New Enrolment': 'txn',
    'Cancelled Transaction': 'txn',
    'Profile self update': 'cust',
}

const TYPED_PREFIXES = ['txn:', 'pay:', 'cust:', 'mem:', 'merge:']

const parseTypedReference = (value) => {
    for (const prefix of TYPED_PREFIXES) {
        if (!value.startsWith(prefix)) continue
        const rest = value.slice(prefix.length)
        const [display, id] = rest.split('|')
        const kind = prefix.slice(0, -1)
        return {
            kind,
            display: display ?? '',
            id: id ?? '',
            navigable: kind !== 'merge' && Boolean(id),
        }
    }
    return null
}

const parseLegacyPipeReference = (value, { message, familyId }) => {
    const [display, id] = value.split('|')
    const label = (display ?? '').trim()
    const refId = (id ?? '').trim()
    if (!refId) return null

    const legacyKind = LEGACY_LABEL_KIND[label]
    if (legacyKind) {
        return { kind: legacyKind, display: label, id: refId, navigable: true }
    }

    const msg = (message ?? '').toLowerCase()
    if (msg.includes('new member')) {
        return { kind: 'cust', display: label, id: refId, navigable: true }
    }
    if (msg.includes('member profile')) {
        return {
            kind: 'mem',
            display: label,
            id: refId,
            familyId: familyId ?? '',
            navigable: Boolean(familyId),
        }
    }

    return null
}

const parsePlainGuidReference = (value, message) => {
    if (!GUID_PATTERN.test(value)) return null

    if ((message ?? '').includes('Customer merge completed')) {
        return { kind: 'merge', display: 'Customer Merge', id: value, navigable: false }
    }

    return { kind: 'text', display: value, id: value, navigable: false }
}

/**
 * Parse a customer activity reference string into display and navigation metadata.
 *
 * @param {string|null|undefined} reference
 * @param {{ message?: string, familyId?: string }} [context]
 * @returns {{ kind: string, display: string, id: string, familyId?: string, navigable: boolean } | null}
 */
export const parseActivityReference = (reference, { message, familyId } = {}) => {
    if (typeof reference !== 'string') return null
    const value = reference.trim()
    if (!value) return null

    const typed = parseTypedReference(value)
    if (typed) {
        if (typed.kind === 'mem' && familyId) {
            return { ...typed, familyId, navigable: Boolean(typed.id && familyId) }
        }
        return typed
    }

    if (value.includes('|')) {
        const legacy = parseLegacyPipeReference(value, { message, familyId })
        if (legacy) return legacy
    }

    const plainGuid = parsePlainGuidReference(value, message)
    if (plainGuid) return plainGuid

    return { kind: 'text', display: value, id: '', navigable: false }
}

export default parseActivityReference
